import { Box, Modal } from "@mui/material";
import React, { useState } from 'react';
import CtaComponent from "../../../../components/reusable-ui/cta";
import { CTA_SIZE, CTA_TYPE } from "../../../../data/constants";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { setLocalStorage } from "../../../../utils";
import { RECON_WALKTHROUGH } from "../../../../data/local-storage-constants";
import ReconInfoSection, { InfoSectionType } from "./info-section";

const STEPS = [
  { element: "#recon-upload-section", popover: { header: "Upload", description: "Start reconciling your Zomato/Swiggy payout files easily by selecting ‘Upload New File’ to begin." } },
  { element: "#recon-pending-button", popover: { header: "Check Pending", description: "View and manage files with unresolved issues here for quick resolution." } },
  { element: "#recon-reports-view", popover: { header: "View Reconciliation Reports", description: "See your uploaded files and track the reconciliation status at a glance." } },
]

const driverObj = driver({
  showProgress: true,
  steps: STEPS
});

export const ReconFeatureTour = ({ skipTour }: { skipTour: () => void }) => {
  const [intro, setIntro] = useState(true);

  function start() {
    setIntro(false);
    driverObj.drive();
  }

  return (
    <>
      <Modal open={intro}>
        <Box className='modal-center w-[960px] rounded-[16px] px-[25px]  pt-[31px] pb-[19px]' >
          <ReconInfoSection type={InfoSectionType.modal} />
          <div className="flex flex-col gap-10 mt-[30px]">
            <CtaComponent ctaSize={CTA_SIZE.medium} ctaText="Start Tour" ctaType={CTA_TYPE.active_cta} onCtaClick={start} />
            <CtaComponent ctaSize={CTA_SIZE.medium} ctaText="Skip" ctaType={CTA_TYPE.secondary_active_cta} onCtaClick={skipTour} />
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default ReconFeatureTour;

